import { useSelector } from "react-redux";
import { markerSize } from "../../config";
import { getCalculatedHotspotCoordinates } from "../../redux/selectors";

const [w, h] = markerSize;
function Marker({ frame, number, style = {}, ...rest }) {
  const framifySelector = (selector) => (state) => selector(state, { frame });
  const coordinates = useSelector(
    framifySelector(getCalculatedHotspotCoordinates)
  );
  const { x, y } = coordinates ?? {};
  const commonStyle = {
    position: "absolute",
    left: `${x}%`,
    top: `${y}%`,
    width: `${w}px`,
    height: `${h}px`,
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    boxSizing: "border-box",
    background: "black",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "10px",
    fontWeight: 700,
    fontFamily: "Source Code Pro",
    pointerEvents: "none",
  };
  return <div style={{ ...commonStyle, ...style }}>{number}</div>;
}

export default Marker;
